import { STATUS_META, MODE_META } from "@/lib/constants";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-slate-500 text-sm mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return <div className={`pf-card p-5 sm:p-6 ${className}`} {...rest}>{children}</div>;
}

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-700" };
  return <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${m.cls}`}>{m.label}</span>;
}

export function ModeBadge({ mode, glow }) {
  const m = MODE_META[mode] || MODE_META.MOCK;
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold tracking-wide ${m.cls} ${glow && mode === "SANDBOX" ? "pf-glow" : ""}`}>{m.label}</span>;
}

export function Empty({ children }) {
  return <div className="text-center text-slate-400 text-sm py-12 border-2 border-dashed border-slate-200 rounded-xl">{children}</div>;
}

export function Btn({ variant = "primary", className = "", ...rest }) {
  const base = "inline-flex items-center justify-center gap-2 rounded-xl text-sm font-semibold px-4 py-2.5 transition-all active:scale-[0.98] disabled:opacity-60";
  const styles = {
    primary: "pf-gradient text-white hover:opacity-95",
    secondary: "bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 hover:-translate-y-0.5 hover:shadow-sm",
    ghost: "text-slate-600 hover:bg-slate-100",
    danger: "bg-rose-600 text-white hover:bg-rose-700",
    success: "bg-emerald-600 text-white hover:bg-emerald-700",
  };
  return <button className={`${base} ${styles[variant]} ${className}`} {...rest} />;
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-slate-700">{label}</span>
      <div className="mt-1.5">{children}</div>
    </label>
  );
}

export function Input(props) {
  return <input {...props} className={`w-full border border-slate-200 rounded-xl px-3.5 py-2.5 text-sm bg-white outline-none focus:border-[#3457d5] focus:ring-2 focus:ring-[#3457d5]/15 ${props.className || ""}`} />;
}

export function Textarea(props) {
  return <textarea {...props} className={`w-full border border-slate-200 rounded-xl px-3.5 py-2.5 text-sm bg-white outline-none focus:border-[#3457d5] focus:ring-2 focus:ring-[#3457d5]/15 ${props.className || ""}`} />;
}

export function Select(props) {
  return <select {...props} className={`w-full border border-slate-200 rounded-xl px-3 py-2.5 text-sm bg-white outline-none focus:border-[#3457d5] focus:ring-2 focus:ring-[#3457d5]/15 ${props.className || ""}`} />;
}
